// extracted by mini-css-extract-plugin
export default {"priceStrikeThrough":"_1vfwswf"};